/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_EditInputs */

const en_us2_quick_workout_edit = /** @type {(inputs: Quick_Workout_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjust`)
};

const pt_br2_quick_workout_edit = /** @type {(inputs: Quick_Workout_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar`)
};

const es_419_quick_workout_edit = /** @type {(inputs: Quick_Workout_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar`)
};

const pt_pt2_quick_workout_edit = /** @type {(inputs: Quick_Workout_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar`)
};

const fr_fr2_quick_workout_edit = /** @type {(inputs: Quick_Workout_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuster`)
};

const de_de2_quick_workout_edit = /** @type {(inputs: Quick_Workout_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anpassen`)
};

const it_it2_quick_workout_edit = /** @type {(inputs: Quick_Workout_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica`)
};

/**
* | output |
* | --- |
* | "Adjust" |
*
* @param {Quick_Workout_EditInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_edit = /** @type {((inputs?: Quick_Workout_EditInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_EditInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_edit(inputs)
	if (locale === "es-419") return es_419_quick_workout_edit(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_edit(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_edit(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_edit(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_edit(inputs)
	return en_us2_quick_workout_edit(inputs)
});
export { quick_workout_edit as "quick-workout.edit" }